import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import data from './data'
import getVehicleTags from './vehicle-tags'

const STATIC_ASSETS_URL = getEnv(Env.StaticAssetsUrl)

const getMake = (make: string) => {
  if (!make) {
    return ''
  }

  try {
    return data[make].displayName
  } catch (e) {
    return make
  }
}

const getModel = (make: string, model: string) => {
  if (!make || !model) {
    return ''
  }

  if (data[make] && data[make].models && data[make].models[model]) {
    return data[make].models[model]
  }

  // make and model is not found!
  // todo track an event for this!
  return model
}

const getModelsByMake = (make: string) => {
  try {
    const models = data[make].models

    return Object.keys(models).map((modelKey) => ({
      label: models[modelKey],
      value: modelKey,
    }))
  } catch (e) {
    return []
  }
}

const tidyString = (str: string) => str.replace(/\s/g, '--').toLowerCase()

const getDefaultHeroSrc = () => `${STATIC_ASSETS_URL}/recommended/_default/car-cover_hero.png`

const getDefaultThumbnailSrc = () => `${STATIC_ASSETS_URL}/recommended/_default/car-cover_thumbnail.png`

// TODO: Temporary src retrieval for review images until we use reviews API to retrieve image path
const getReviewModelThumbnailSrc = (make: string, model: string) =>
  `${STATIC_ASSETS_URL}/reviews/${tidyString(make)}/${tidyString(model)}_thumbnail.jpg`

const getMakeLogoSrc = (make: string) => `${STATIC_ASSETS_URL}/recommended/logos/${tidyString(make)}_grey_200.png`

export {
  data as manufacturers,
  getVehicleTags,
  getMake,
  getModel,
  getModelsByMake,
  getDefaultHeroSrc,
  getDefaultThumbnailSrc,
  getReviewModelThumbnailSrc,
  getMakeLogoSrc,
}
